import { createZustandStore } from '../createZustandStore';
import type { IBillingInfoFormSlice, IPaymentMethodsSlice, IUpdateBillingSlice } from '../slices';
import {
  createAlertSlice,
  createBillingInfoFormSlice,
  createPaymentMethodsSlice,
  createUpdateBillingSlice,
  createOverduePaymentButtonSlice,
} from '../slices';

export type IOverdueBalancePageStore = IBillingInfoFormSlice & IPaymentMethodsSlice & IUpdateBillingSlice;

export const useOverdueBalancePageStore = createZustandStore(
  createBillingInfoFormSlice,
  createPaymentMethodsSlice,
  createUpdateBillingSlice,
  createAlertSlice,
  createOverduePaymentButtonSlice
);
